export default "__VITE_ASSET__Job25nZs__"